export default "__VITE_PUBLIC_ASSET__c016a4d2__"